<template>
  <div class="menu_submenu">
    <div class="submenu-column submenu-column_1">
      <ul class="submenu_inner submenu_inner_level-1">
        <li class="submenu_item submenu_item_level-2">
          <span class="submenu_link submenu_link_nolink"><span class="submenu_link-text">Histórico</span></span>
          <ul class="submenu_inner_level-2">
            <nav-sub-link @click="$router.push({name: 'meus-lances'})" label="Lances e Arremates" />
            <nav-sub-link @click="$router.push({name: 'favoritos'})" label="Meus Favoritos" />
<!--            <li class="submenu_item submenu_item_level-3">
              <a class="submenu_link" href="#" data-menu-level="3">
                <span class="submenu_link-icon" style="background-image: url('https://s3n.tmimgcdn.com/navigation-node&#45;&#45;image_file-5e25d6b02fbac.svg');"></span>
                <span class="submenu_link-link-text">Minhas Habilitações</span>
              </a>
            </li>-->
          </ul>
        </li>
      </ul>
    </div>
    <div class="submenu-column submenu-column_1">
      <ul class="submenu_inner submenu_inner_level-1">
        <li class="submenu_item submenu_item_level-2">
          <span class="submenu_link submenu_link_nolink"><span class="submenu_link-text">Configurações</span></span>
          <ul class="submenu_inner_level-2">
            <nav-sub-link @click="$router.push({name: 'conta'})" label="Meu Cadastro" />
            <nav-sub-link @click="$router.push({name: 'conta'})" label="Definições e Preferências" />
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import NavSubLink from './NavSubLink'
export default {
  name: 'ArrematanteSubmenu',
  components: {NavSubLink},
  inject: ['nav'],
  methods: {
    click () {
      this.nav.clickEvent()
      return true
    }
  }
}
</script>
